import React from 'react';
import Image from '../../../components/AppImage';

import Button from '../../../components/ui/Button';

const FeaturedMenu = ({ onOrderClick }) => {
  const featuredItems = [
  {
    id: 1,
    name: "Beef Rolex",
    description: "Delicious chapati rolled with seasoned beef, eggs, and fresh vegetables",
    price: "25,000 SSP",
    image: "/assets/images/Rolex_Beef-1781075102839.jpeg",
    imageAlt: "Beef rolex wrap with golden chapati filled with seasoned beef and vegetables on white plate",
    badge: "Popular",
    badgeColor: "bg-primary"
  },
  {
    id: 2,
    name: "Vegetable Rolex",
    description: "Soft chapati wrapped with tender chicken, eggs, and crisp vegetables",
    price: "20,000 SSP",
    image: "/assets/images/Rolex_Veg-1781075193209.jpeg",
    imageAlt: "Chicken rolex with grilled chicken and fresh vegetables wrapped in warm chapati",
    badge: "Best Seller",
    badgeColor: "bg-accent"
  },
  {
    id: 3,
    name: "Fruit Salad Combo",
    description: "Fresh seasonal fruits mixed together. A healthy and refreshing choice",
    price: "20,000 SSP",
    image: "/assets/images/Fruit_Salad-1781075379070.jpeg",
    imageAlt: "Colorful fresh fruit salad with mixed tropical fruits in bowl",
    badge: "Healthy",
    badgeColor: "bg-secondary"
  },
  {
    id: 4,
    name: "Fresh Juice",
    description: "Freshly squeezed fruit juice made to order with natural ingredients",
    price: "15,000 SSP",
    image: "https://i.ibb.co/HLkV7KFx/2.jpg",
    imageAlt: "Fresh fruit juice in glass with colorful fruits",
    badge: "Fresh Daily",
    badgeColor: "bg-primary"
  }];


  return (
    <section id="featured-menu" className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Featured Menu
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover our most loved dishes, prepared fresh daily with quality ingredients
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {featuredItems?.map((item) =>
          <div
            key={item?.id}
            className="bg-card rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group">

              <div className="relative h-48 md:h-56 overflow-hidden">
                <Image
                src={item?.image}
                alt={item?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              
                <div className="absolute top-3 right-3">
                  <span className={`${item?.badgeColor} text-white text-xs font-semibold px-3 py-1 rounded-full`}>
                    {item?.badge}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="text-lg md:text-xl font-bold text-foreground mb-2 line-clamp-1">
                  {item?.name}
                </h3>
                <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
                  {item?.description}
                </p>

                <div className="flex items-center justify-between">
                  <span className="text-xl md:text-2xl font-bold text-primary whitespace-nowrap">
                    {item?.price}
                  </span>
                  <Button
                  variant="outline"
                  size="sm"
                  iconName="ShoppingCart"
                  iconPosition="left"
                  onClick={() => onOrderClick(item?.name, item?.price)}>

                    Order
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="text-center mt-8 md:mt-12">
          <Button
            variant="default"
            size="lg"
            iconName="UtensilsCrossed"
            iconPosition="left"
            onClick={() => window.location.href = '/menu'}>

            View Full Menu
          </Button>
        </div>
      </div>
    </section>);

};

export default FeaturedMenu;